import { Link } from 'react-router-dom';
import type { Order } from '@/services/orders';
import { OrderStatusBadge } from './OrderStatusBadge';

interface OrderCardProps {
  readonly order: Order;
}

export const OrderCard = ({ order }: OrderCardProps) => {
  return (
    <Link
      to={`/orders/${order.orderId}`}
      className="order-card"
      style={{
        display: 'block',
        borderRadius: 'var(--radius-lg)',
        border: '1px solid var(--border-default)',
        backgroundColor: 'var(--bg-surface)',
        padding: 'var(--space-4)',
        textDecoration: 'none',
        transition: `box-shadow var(--duration-normal) var(--ease-out)`,
      }}
    >
      <div className="flex flex-col sm:flex-row sm:items-center justify-between" style={{ gap: 'var(--space-2)' }}>
        <div style={{ minWidth: 0 }}>
          <p
            style={{
              fontWeight: 'var(--font-weight-medium)',
              color: 'var(--text-primary)',
            }}
          >
            Order #{order.orderId.slice(-8).toUpperCase()}
          </p>
          <p
            style={{
              marginTop: 'var(--space-1)',
              fontSize: 'var(--text-sm)',
              color: 'var(--text-tertiary)',
            }}
          >
            {order.type === 'quote' ? 'Custom Print' : 'Catalog Product'}
            {order.materialId && ` | ${order.materialId.toUpperCase()}`}
            {' | '}
            {new Date(order.createdAt).toLocaleDateString()}
          </p>
        </div>
        <div className="flex items-center" style={{ gap: 'var(--space-3)', flexShrink: 0 }}>
          <span
            style={{
              fontSize: 'var(--text-sm)',
              fontWeight: 'var(--font-weight-semibold)',
              color: 'var(--text-primary)',
            }}
          >
            ${order.totalPrice.toFixed(2)}
          </span>
          <OrderStatusBadge status={order.status} />
        </div>
      </div>
    </Link>
  );
};
